// src/components/AnimatedCounter.js
import React, { useState, useEffect, useRef } from "react";

export default function AnimatedCounter({ title = "Compteur", target = 100, duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  // Détecte quand l'élément est visible à l'écran
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  // Animation du compteur
  useEffect(() => {
    if (!visible) return;

    let start = 0;
    const increment = target / (duration / 50);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 50);

    return () => clearInterval(timer);
  }, [visible, target, duration]);

  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "300px",
        margin: "10px auto",
        padding: "10px",
        borderLeft: "4px solid #A64343", // Bordure en bordeaux
        backgroundColor: "#F5EFE6", // Fond crème
        borderRadius: "4px",
        textAlign: "center",
      }}
    >
      <h3 style={{ marginBottom: "10px", color: "#1A1A1A" }}>{title}</h3> {/* Titre en noir */}
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "2rem",
          fontWeight: "bold",
          color: "#A64343", // Couleur du compteur en bordeaux
          margin: 0,
        }}
      >
        {count}+
      </p>
    </div>
  );
}